import KpiCard from 'pages/Admin/Analytics/components/KpiCard/KpiCard';
import { KpiMeta } from 'pages/Admin/Analytics/components/KpiMeta/KpiMeta';
import { currencyFormatter } from 'pages/Admin/Analytics/utils/monthlySeries';
import { useGetCertRevenueBreakdown, useGetMonthlyChurnRates, useGetMonthlyRefunds } from 'queryHooks/Admin/analytics';

export const FinancialKpis = () => {
  const { data: revenueData } = useGetCertRevenueBreakdown();
  const { data: refundsData } = useGetMonthlyRefunds();
  const { data: churnData } = useGetMonthlyChurnRates();

  const totalRevenue = revenueData?.reduce((sum, e) => sum + e.fullPriceIncome + e.premiumIncome + e.otherDiscountedIncome, 0) ?? 0;

  const totalRefunds = refundsData?.reduce((sum, e) => sum + e.totalAmount, 0) ?? 0;
  const totalRefundCount = refundsData?.reduce((sum, e) => sum + e.count, 0) ?? 0;

  const refundRate = totalRevenue > 0 ? (totalRefunds / totalRevenue) * 100 : 0;

  const latestChurn = churnData && churnData.length > 0 ? churnData[churnData.length - 1].rate : null;
  const prevChurn = churnData && churnData.length > 1 ? churnData[churnData.length - 2].rate : null;
  const churnDelta = latestChurn !== null && prevChurn !== null ? latestChurn - prevChurn : null;

  return (
    <>
      <KpiCard label='Total revenue (6 mo)' sources={['RECURLY']} value={currencyFormatter.format(totalRevenue)} />

      <KpiCard label='Total refunds (6 mo)' sources={['RECURLY']} value={currencyFormatter.format(totalRefunds)}>
        <KpiMeta tone='neutral'>{totalRefundCount} transactions</KpiMeta>
      </KpiCard>

      <KpiCard label='Refund rate (6 mo)' sources={['RECURLY']} value={`${refundRate.toFixed(1)}%`}>
        <KpiMeta tone={refundRate < 5 ? 'positive' : refundRate < 10 ? 'neutral' : 'negative'}>
          {refundRate < 5 ? 'Healthy' : refundRate < 10 ? 'Moderate' : 'High'}
        </KpiMeta>
      </KpiCard>

      <KpiCard label='Churn rate (latest)' sources={['RECURLY']} value={latestChurn !== null ? `${latestChurn.toFixed(2)}%` : '—'}>
        {churnDelta !== null && (
          <KpiMeta tone={churnDelta <= 0 ? 'positive' : 'negative'}>
            {churnDelta > 0 ? '▲' : '▼'} {Math.abs(churnDelta).toFixed(2)}pp vs prev month
          </KpiMeta>
        )}
      </KpiCard>
    </>
  );
};

export default FinancialKpis;
